import { useEffect } from 'react';
import { injectScriptTag } from '../hooks.utils';
import { chatScriptContent } from './ChatBot.consts';

export const useChatBot = () => {
  useEffect(() => {
    injectScriptTag(chatScriptContent);
  }, []);
};
